import { putUpdateReserveDetail_service } from "@Services/reserve/putUpdateReserveDetail.service";

export const putUpdateReserveDetail_adapter = async (payload) => {
  // "Por asignar": el combo usa value "" → se envía null (sin estilista).
  const adaptEditReserveDetails = payload.editReserveDetails.map((detail) => ({
    reserveDetailId: detail.id,
    priceServiceId: detail.service,
    employeeId: detail.employee ? Number(detail.employee) : null,
    reserveHour: detail.schedule,
    duration: detail.duration != null ? detail.duration : undefined,
    isFija: detail.isFija || false,
  }));
  const adaptNewReserveDetails = payload.newReserveDetails.map((detail) => ({
    priceServiceId: detail.service,
    employeeId: detail.employee ? Number(detail.employee) : null,
    reserveHour: detail.schedule,
    promoId: 0,
    duration: detail.duration != null ? detail.duration : undefined,
    isFija: detail.isFija || false,
  }));

  const adaptRequest = {
    reserveId: payload.reserveId,
    newStatus: payload.newStatus,
    deleteReserveDetailsIds: payload.deleteReserveDetailsIds,
    newReserveDetails: adaptNewReserveDetails,
    editReserveDetails: adaptEditReserveDetails,
    observation: payload.observation,
    dateAttention: payload.dateAttention,
  };

  const response = await putUpdateReserveDetail_service(adaptRequest);
  if (!response.isSuccess) {
    return {
      ...response,
      data: null,
    };
  }
  return {
    ...response,
    data: response.data,
  };
};
